import { TrainningLogbook } from '@/models/TrainningActivity'

import { Component, Option } from '../models/Specialty'

export default {
  methods: {
    fetchTrainningActivity() {
      //  if (TrainningLogbook.query().first()) return Promise.resolve()

      return fetch(
        `${process.env.VUE_APP_API_URL}/training-activity/airtable`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        }
      )
        .then(res => {
          if (res.ok) {
            return res.json()
          } else {
            throw Error('could not fetch Trainning Activity Parameters')
          }
        })
        .then(res => {
          this.seedTAModels(res)
        })
        .catch(err => {
          this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Something went wrong'
          )
        })
    },
    seedTAModels(res) {
      TrainningLogbook.create({ data: res.logbooks || [] })
      Option.insert({ data: res.options })
      Component.insert({
        data: res.components.map(c => ({
          ...c,
          uid: 'trainingActivity.' + c.id
        }))
      })
    }
  }
}
